
import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';
import { StayRoomModule } from '@/store/modules/stayRoom';
import { parseConcatNumber } from '@/utils/filters';
import { getOptionItemList } from '@/api/optionItem';
import OptionSelect from './OptionSelect.vue';

@Component({
  name: 'BasicForm',
  components: {
    OptionSelect,
  },
})
export default class extends Vue {
  mounted() {
    // this.getBedTypeList();
  }

  get formData() {
    return StayRoomModule.form;
  }

  get selectedOptions() {
    const datas: any = [];
    if (StayRoomModule.form.optionTypes) {
      StayRoomModule.form.optionTypes.forEach((optionType: any) => {
        optionType.options.forEach((option: any) => {
          if (option.useStatus) datas.push(option);
        });
      });
    }
    return datas;
  }

  private form: any = {
    images: [],
    optionTypes: [],
  }

  private break = false;

  private showBreak() {
    this.break = true;
  }

  private formFileList: any = [];

  private bedTypeList: any = [];

  private fileSizeLimit = 5;

  private apiUrl = process.env.VUE_APP_BASE_API;

  private optionSelectVisible = false;

  private rules = {
    name: [
      { required: true, message: '객실명을 입력하세요.', trigger: ['blur', 'change'] },
    ],
    introduction: [
      { required: true, message: '한 줄 소개를 입력하세요.', trigger: ['blur', 'change'] },
    ],
    standardPeople: [
      { required: true, message: '기준인원을 입력하세요.', trigger: ['blur', 'change'] },
    ],
    maxPeople: [
      { required: true, message: '최대인원을 입력하세요.', trigger: ['blur', 'change'] },
    ],
    bedType: [
      // { required: true, message: '침구를 선택하세요.', trigger: ['blur', 'change'] },
    ],
    toliet: [
      // { required: true, message: '화장실을 선택하세요.', trigger: ['blur', 'change'] },
    ],
    images: [
      { required: true, message: '이미지를 선택하세요.', trigger: ['change', 'blur'] },
    ],
    optionTypes: [
      { required: true, message: '시설 옵션을 선택하세요.', trigger: ['change', 'blur'] },
    ],
    usageInstruction: [
      { required: true, message: '이용안내를 입력하세요.', trigger: ['blur', 'change'] },
    ],
    checkIn: [
      { required: true, message: '체크인 시간을 입력하세요.', trigger: ['blur', 'change'] },
    ],
    checkOut: [
      { required: true, message: '체크아웃 시간을 입력하세요.', trigger: ['blur', 'change'] },
    ],
  };

  private handleBeforeUpload(uploadFile:File, isPhoto:boolean) {
    const fileSizeLimitByMb = this.fileSizeLimit * 1024 * 1024;
    if (isPhoto) {
      const isImageFile = uploadFile.type.split('/')[0] === 'image';
      if (!isImageFile) {
        this.$message.warning('이미지 파일만 업로드 가능합니다.');
        return false;
      }
    }
    if (uploadFile.size > fileSizeLimitByMb) {
      this.$message.warning(`파일 업로드 최대용량은 ${this.fileSizeLimit}MB입니다.`);
      return false;
    }
    return true;
  }

  private handleRemoveImageFile(file: any) {
    const index = this.formData.images.findIndex((imgFile: any) => imgFile.fileUid === file.fileUid);
    if (index > -1) this.formData.images.splice(index, 1);
  }

  private handleSuccessUploadImageFile(res: any) {
    this.formData.images.push({ fileUid: res.uid });
  }

  private getBedTypeList() {
    getOptionItemList('BED_TYPE').then((res) => {
      this.bedTypeList = res.data;
    });
  }

  private handleClickLeftFile(file: any) {
    const index = this.formData.images.findIndex((imgFile: any) => imgFile.fileUid === file.fileUid);
    if (index > 0) {
      this.formData.images.splice(index - 1, 0, this.formData.images.splice(index, 1)[0]);
    }
  }

  private handleClickRightFile(file: any) {
    const index = this.formData.images.findIndex((imgFile: any) => imgFile.fileUid === file.fileUid);
    if (index < this.formData.images.length - 1) {
      this.formData.images.splice(index + 1, 0, this.formData.images.splice(index, 1)[0]);
    }
  }
}
